import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  desktopMarginsCutoff,
  mobileMarginVal,
  desktopMarginVal,
} from "../../../styleConstants";
import SignOutButton from "./SignOutButton";
import ContactSection from "./ContactSection";

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: calc(100% - ${2 * mobileMarginVal}px);

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    width: calc(100% - ${2 * desktopMarginVal}px);
  }
`;

const SignOutDivider = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

const SignOutSection = styled.div`
  padding-top: 14px;
  padding-bottom: 14px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

const Footer = ({ setFooterHeight }) => {
  const footerRef = useRef(null);

  // The parent component needs to know the footer height to leave space when scrolling.
  useEffect(() => {
    setFooterHeight(footerRef.current.clientHeight + 1);
  }, [footerRef]);

  return (
    <FooterWrapper ref={footerRef}>
      {/* The ContactSection is just a message to contact us for help. */}
      <ContactSection />
      <SignOutDivider />
      <SignOutSection>
        <SignOutButton />
      </SignOutSection>
    </FooterWrapper>
  );
};

Footer.propTypes = {
  setFooterHeight: PropTypes.func,
};

export default Footer;
